<template>
  <el-container style="height:100vh">
      <el-aside :width="collapsed ? '64px' : '200px'" style="background:#fff;border-right:1px solid #ebeef5">
        <div style="height:64px;display:flex;align-items:center;justify-content:center;font-weight:600">
          <span v-if="!collapsed">运输帮 管理</span>
          <span v-else>运</span>
        </div>
        <el-menu :default-active="active" class="el-menu-vertical-demo" router @select="onSelect" :collapse="collapsed">
          <el-menu-item index="/">🏠 <span>仪表盘</span></el-menu-item>
          <el-menu-item index="/users">👥 <span>会员管理</span></el-menu-item>
          <el-menu-item index="/admins">🔑 <span>管理员管理</span></el-menu-item>
        </el-menu>
      </el-aside>

    <el-container>
      <el-header style="height:64px;padding:0 16px;display:flex;align-items:center;justify-content:space-between">
        <div style="display:flex;align-items:center;gap:8px">
          <el-button type="text" icon size="small" @click="toggleCollapsed">
            <span v-if="!collapsed">Collapse ◀</span>
            <span v-else>▶</span>
          </el-button>
        </div>
        <div style="display:flex;align-items:center;gap:12px">
          <div v-if="admin" style="display:flex;align-items:center;gap:8px">
            <div style="width:36px;height:36px;border-radius:50%;background:#409EFF;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:600">{{ admin.username.charAt(0).toUpperCase() }}</div>
            <div style="line-height:1">
              <div style="font-weight:600">{{ admin.username }}</div>
              <div style="font-size:12px;color:#888">{{ admin.role || 'admin' }}</div>
            </div>
          </div>
          <el-button type="text" @click="onLogout">登出</el-button>
        </div>
      </el-header>
      <el-main style="padding:16px;overflow:auto;background:#f5f7fa">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'AdminLayout',
  setup () {
    const route = useRoute()
    const router = useRouter()
    const active = computed(() => route.path === '/' ? '/' : `/${route.path.split('/')[1]}`)
    const onSelect = (index) => { router.push(index) }

    const collapsed = ref(false)
    const toggleCollapsed = () => { collapsed.value = !collapsed.value }

    const admin = ref(null)
    try {
      const raw = localStorage.getItem('admin_info')
      if (raw) admin.value = JSON.parse(raw)
    } catch (e) {}

    const onLogout = () => {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
      router.push('/login')
    }

    return { active, onSelect, collapsed, toggleCollapsed, admin, onLogout }
  }
}
</script>

<style scoped>
.el-menu-vertical-demo {
  border-right: none;
}
</style>
